import { StickyCart } from '@/components/web/sticky-cart';
import { cn } from '@/lib/utils';
import { type ReactNode } from 'react';

interface SearchResultsLayoutProps {
  children: ReactNode;
  className?: string;
  showCart?: boolean;
  priceRail?: ReactNode;
}

export function SearchResultsLayout({ children, className = '', showCart = true, priceRail }: SearchResultsLayoutProps) {
  return (
    <div className={cn('container px-4 py-8', className)}>
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
        {/* Results Column */}
        <div className="lg:col-span-8">{children}</div>

        {/* Cart Column - Desktop Only */}
        {showCart && (
          <div className="hidden lg:col-span-4 lg:block">
            {priceRail && <div className="mb-4">{priceRail}</div>}
            <StickyCart />
          </div>
        )}
      </div>
    </div>
  );
}
